export default {"src":"/_next/static/media/pharmacy-order-four.57085cbd.svg","height":329,"width":324,"blurWidth":0,"blurHeight":0};